import { render, staticRenderFns } from "./VueGridLayout.vue?vue&type=template&id=3f07592c&"
import script from "./VueGridLayout.vue?vue&type=script&lang=ts&"
export * from "./VueGridLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports